<template>
  <ctf-rich-text
    v-if="fields && fields.content"
    class="my-10"
    :document="fields.content"
  />
</template>

<script>
export default {
  name: 'RichText',
  props: {
    fields: {
      type: Object,
      default: null
    }
  }
}
</script>
